<template>
  <Layout :linksData="linksData">
    <v-row class="leads-managements w-100">
      <v-col cols="12" :lg="6" class="header-line-title">
        <div class="leads-managements-link d-flex align-center ga-2 my-3">
          <div
            @click="$router.push({ name: 'Accountsmanagement' })"
            class="link cursor-pointer hoverd-style-line d-flex align-center ga-2"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                fill="#1F666A"
              />
            </svg>
            <span>Accounts</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <div class="account-card">
          <div class="element">
            <div class="title">Accounts</div>
            <div class="d-flex flex-column ga-3 align-center justify-center">
              <div class="icon">
                <svg
                  width="69"
                  height="70"
                  viewBox="0 0 69 70"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="34.5"
                    cy="35"
                    rx="34.5"
                    ry="35"
                    fill="#DDECED"
                    fill-opacity="0.4"
                  />
                  <path
                    d="M44.79 34.7122C46.1272 33.5957 47.0068 31.9769 47.2462 30.192C47.4855 28.407 47.0662 26.5931 46.0754 25.1268C45.0845 23.6604 43.5982 22.6544 41.925 22.3175C40.2518 21.9806 38.5203 22.3387 37.09 23.3175C36.4907 22.3036 35.6874 21.4421 34.7373 20.7945C33.7873 20.1469 32.714 19.7293 31.5939 19.5713C30.4739 19.4132 29.3347 19.5188 28.2576 19.8804C27.1805 20.242 26.1921 20.8507 25.3628 21.6631C24.5335 22.4755 23.8838 23.4716 23.46 24.5804C23.0362 25.6891 22.8487 26.8832 22.911 28.0775C22.9733 29.2717 23.2838 30.4367 23.8204 31.4893C24.3569 32.5419 25.1063 33.4563 26.0151 34.1671C23.8593 35.1072 22.0169 36.7057 20.723 38.7587C19.429 40.8117 18.7422 43.2262 18.7501 45.6941C18.7501 46.6838 19.1351 48.1181 20.9701 49.3248C23.1651 50.7749 26.865 51.5 30.565 51.5C34.115 51.5 37.665 50.8279 39.885 49.4889H40.57C43.79 49.4889 47.775 48.8326 49.645 46.9326C49.9809 46.6219 50.2525 46.2409 50.4427 45.8138C50.6328 45.3866 50.7375 44.9224 50.75 44.4504C50.7482 42.392 50.1848 40.378 49.1275 38.6505C48.0702 36.9229 46.564 35.5554 44.79 34.7122ZM40.635 24.376C41.4238 24.3762 42.1995 24.5898 42.8884 24.9964C43.5774 25.4029 44.1567 25.9891 44.5716 26.6992C44.9865 27.4093 45.2231 28.2199 45.259 29.0539C45.2948 29.888 45.1288 30.7179 44.7766 31.465C44.4244 32.2121 43.8978 32.8516 43.2466 33.3227C42.5954 33.7939 41.8413 34.0812 41.0558 34.1573C40.2703 34.2334 39.4794 34.0958 38.7583 33.7576C38.0371 33.4194 37.4095 32.8918 36.935 32.2248C37.5796 31.2232 38.0039 30.0815 38.177 28.8836C38.35 27.6856 38.2673 26.4619 37.935 25.3022C38.7204 24.7003 39.6653 24.3761 40.635 24.376ZM36.325 34.7863C35.9385 34.5588 35.5413 34.3521 35.135 34.1671C35.285 34.0507 35.435 33.9289 35.58 33.7966C35.8507 34.1308 36.1503 34.4373 36.475 34.7122L36.325 34.7863ZM24.8851 27.6256C24.8851 26.4344 25.2188 25.2699 25.844 24.2795C26.4692 23.289 27.3579 22.5171 28.3976 22.0612C29.4373 21.6054 30.5814 21.4861 31.6851 21.7185C32.7889 21.9509 33.8027 22.5245 34.5985 23.3668C35.3942 24.2091 35.9361 25.2823 36.1557 26.4506C36.3752 27.6189 36.2626 28.8299 35.8319 29.9304C35.4012 31.031 34.6719 31.9716 33.7362 32.6334C32.8005 33.2952 31.7004 33.6484 30.575 33.6484C29.0664 33.647 27.6199 33.012 26.5531 31.8828C25.4863 30.7536 24.8864 29.2225 24.8851 27.6256ZM22.0401 47.5253C21.1951 46.9696 20.7501 46.3557 20.7501 45.6941C20.7435 43.2823 21.5319 40.9435 22.9794 39.0809C24.427 37.2183 26.443 35.9485 28.68 35.4902C29.9223 35.8361 31.2278 35.8361 32.47 35.4902C34.7057 35.9497 36.7199 37.2202 38.1657 39.0828C39.6114 40.9454 40.398 43.2835 40.39 45.6941C40.39 46.3504 39.965 46.959 39.125 47.5148H39.095C35.34 50.0022 25.7901 49.9969 22.0401 47.5253ZM48.275 45.4083C47.275 46.4668 44.835 47.1602 42.005 47.3348C42.2574 46.8254 42.3895 46.2588 42.39 45.6836C42.3945 43.8892 42.0317 42.1151 41.3265 40.4833C40.6213 38.8516 39.5905 37.4009 38.305 36.2312C38.545 36.1571 38.805 36.0936 39.02 36.0459C39.5482 36.1856 40.0906 36.2567 40.635 36.2576C41.1748 36.2559 41.7123 36.183 42.235 36.0406C44.0731 36.4268 45.7275 37.4764 46.9157 39.0102C48.1039 40.544 48.7523 42.4669 48.75 44.4504C48.7398 44.6382 48.6922 44.8215 48.6104 44.9884C48.5285 45.1554 48.4142 45.3021 48.275 45.4189V45.4083Z"
                    fill="#237276"
                  />
                </svg>
              </div>
              <div class="number">{{ accounts_data.total }}</div>
              <div class="title">Total Accounts</div>
              <div class="disc d-flex align-center ga-3">
                <svg
                  v-if="accounts_data.growth_rate === 'Negative'"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2389_55531)">
                    <path
                      d="M10.4999 20C16.0228 20 20.4999 15.5229 20.4999 10C20.4999 4.47716 16.0228 0 10.4999 0C4.97713 0 0.5 4.47716 0.5 10C0.5 15.5229 4.97713 20 10.4999 20Z"
                      fill="#F2F2F2"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.1593 8.37904C20.4073 8.22681 20.5382 7.93937 20.4902 7.65239L19.5482 2.02494C19.5166 1.83593 19.4103 1.66756 19.2533 1.55766C19.0963 1.44777 18.9018 1.40559 18.7133 1.44059L13.3713 2.43286C13.0915 2.48481 12.8693 2.69783 12.8056 2.97511C12.7419 3.2524 12.8488 3.54107 13.0777 3.70996L15.4375 5.4506L11.372 11.2562L7.65986 8.65373C7.46589 8.51776 7.22585 8.46443 6.99255 8.50549C6.75927 8.54656 6.55185 8.67864 6.41597 8.87267L0.661571 17.09C0.378717 17.494 0.476858 18.0507 0.880775 18.3336C1.28469 18.6164 1.84143 18.5183 2.12429 18.1143L7.36628 10.6287L11.0784 13.2312C11.2724 13.3671 11.5125 13.4205 11.7458 13.3794C11.979 13.3383 12.1865 13.2062 12.3223 13.0122L16.8751 6.51091L19.3616 8.34513C19.5959 8.51786 19.9113 8.53127 20.1593 8.37904Z"
                      fill="#45C948"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2389_55531">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <svg
                  v-else
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3811_94317)">
                    <path
                      d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47716 15.5229 0 10 0C4.47716 0 1.00106e-07 4.47716 1.00106e-07 10C1.00106e-07 15.5229 4.47716 20 10 20Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.6243 1.88573C1.34144 1.48181 0.784699 1.38367 0.380777 1.66653C-0.023142 1.94939 -0.121284 2.50613 0.161572 2.91004L5.916 11.1274C6.05189 11.3214 6.2593 11.4535 6.49259 11.4946C6.72589 11.5357 6.96593 11.4823 7.1599 11.3464L10.8721 8.74393L14.9376 14.5494L12.5778 16.2901C12.3488 16.459 12.2419 16.7477 12.3057 17.025C12.3694 17.3023 12.5916 17.5153 12.8713 17.5673L18.2134 18.5594C18.4019 18.5944 18.5964 18.5523 18.7534 18.4424C18.9104 18.3326 19.0167 18.1641 19.0483 17.9751L19.9903 12.3477C20.0383 12.0607 19.9074 11.7733 19.6594 11.621C19.4114 11.4688 19.096 11.4822 18.8617 11.655L16.3751 13.4892L11.8224 6.98787C11.6865 6.79384 11.4791 6.66176 11.2458 6.62069C11.0125 6.57963 10.7725 6.63296 10.5785 6.76893L6.86631 9.37136L1.6243 1.88573Z"
                      fill="#FF9999"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3811_94317">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <div class="percentage">{{ accounts_data.percentage }}</div>
                <div class="text">Account Growth this year</div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="account-card">
          <div class="element">
            <div class="title">Client Potentiality</div>
            <div class="d-flex justify-space-around align-center p-3 mt-4">
              <div class="w-100" style="width: 160px !important; height: 160px">
                <Doughnut
                  :data="potentiality"
                  ref="doughnutChart"
                  :options="chart2Options"
                />
              </div>
              <div
                class="data d-flex flex-column ga-2 touched-untouched-labels"
              >
                <div
                  v-for="(value, index) in potentiality.datasets[0].data"
                  :key="index"
                  class="d-flex ga-3 align-center"
                >
                  <div class="d-flex align-center ga-2">
                    <div
                      :style="{
                        backgroundColor:
                          potentiality.datasets[0].backgroundColor[index],
                      }"
                      class="dot"
                    ></div>
                    <span style="width: 80px">
                      {{
                        index === 0
                          ? "VIP"
                          : index === 1
                          ? "A"
                          : index === 2
                          ? "B"
                          : "C"
                      }}
                    </span>
                  </div>
                  <span>{{ value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <div class="pa-4 dashboard-card" elevation="2">
          <div class="d-flex justify-space-start">
            <div class="title">Accounts</div>
          </div>
          <div class="">
            <div
              v-for="(item, index) in accounts_country"
              :key="index"
              class="d-flex justify-space-between align-center py-3"
            >
              <div class="logo-name d-flex align-center ga-3">
                <span>{{ item.title }}</span>
              </div>
              <div
                class="number-chart-percent d-flex align-center justify-end ga-2 w-50"
              >
                <div class="chart">
                  <span
                    class="background"
                    :style="{ width: item.percent + '%' }"
                  ></span>
                </div>
                <div class="percent">{{ item.percent }}%</div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </Layout>
</template>
<script>
import Layout from "@/components/crm/layouts/Layout.vue";
import "@/assets/css/crm/crm-moduls.css";
import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import apiClient from "@/core/buildRequest";

ChartJS.register(ArcElement, Tooltip, Legend);

export default {
  components: {
    Layout,
    Doughnut,
  },

  data() {
    return {
      selected_accounts: [],
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Accounts Management", link: "" },
      ],
      store: null,
      chart2Options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "60%",
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            callbacks: {
              label: (context) => {
                let label = context.label || "";
                if (label) {
                  label += ": ";
                }
                if (context.raw !== undefined) {
                  label += `${context.raw}%`;
                }
                return label;
              },
            },
          },
        },
        elements: {
          arc: {
            borderRadius: 7,
            borderWidth: 0,
            hoverBorderWidth: 0,
            hoverOffset: 10,
          },
        },
        animation: {
          animateRotate: true,
          animateScale: true,
          duration: 1000,
        },
        interaction: {
          mode: "nearest",
          intersect: true,
          axis: "xy",
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
      },
      potentiality: {
        datasets: [
          {
            data: [10, 10, 10, 10],
            labels: ["VIP1", "A1", "B", "C"],
            backgroundColor: ["#78DDED", "#78EDA9", "#EDBC78", "#78B5ED"],
            spacing: 5,
          },
        ],
      },
      accounts_country: [
        {
          title: "Saudi Arabia",
          percent: "50%",
        },
        {
          title: "Egypt",
          percent: "50%",
        },
        {
          title: "USA",
          percent: "50%",
        },
      ],
      accounts_data: {
        totla: 0,
        percentage: 0,
        growth_rate: "",
      },
    };
  },
  methods: {
    async getData() {
      try {
        const res = await apiClient.get(
          "/leads-managment/accounts/get/insights"
        );

        this.accounts_data.total = res.data.data.total_accounts;
        this.accounts_data.percentage = res.data.data.yearly_total;
        this.accounts_data.growth_rate = res.data.data.growth_rate;
        const newDataset = {
          ...this.potentiality.datasets[0],
          data: res.data.data.potientiality.map((item) => item.percentage),
          labels: res.data.data.potientiality.map((item) => item.potentiality),
        };
        this.potentiality = {
          datasets: [newDataset],
        };


        if (this.$refs.doughnutChart) {
          // this.$refs.doughnutChart.update();
        }
        this.accounts_country = res.data.data.countries_with_account_count.map(
          (item) => {
            return {
              title: item.name.en,
              percent: item.percentage,
            };
          }
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.account-card {
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 10px 60px 0px #dedede80;
}
.account-card .data .element {
  height: 40px;
  padding: 0px 24px 0px 16px;
  background: #f7f8f8;
  border-radius: 8px;
}
.account-card .element .title {
  font-size: 14px;
  font-weight: bolder;
  line-height: 16.94px;
  color: #0d0d0d;
}

.account-card .number {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  color: #1a1a1a;
}

.account-card .disc {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: #666666;
}

.account-card .percentage {
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  color: #1f0609;
}

.account-card .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.touched-untouched-labels {
  font-size: 14px;
  color: #666666;
}
.number-chart-percent .percent {
  width: 4rem;
}
.number-chart-percent .chart {
  position: relative;
  border-radius: 15px;
  background-color: rgba(240, 240, 240, 0.342);
  width: 85%;
  height: 8px;
}
.number-chart-percent .chart .background {
  background: linear-gradient(90deg, #1f666a 0%, #3f878d 42%, #4f979f 100%);
  border-radius: 15px;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 0px;
  transition: all 1s ease-in-out;
}
</style>
